import { desenhaCirc } from './Aux.js';

export const docartRank = (ling, map, rows, l1, l2, l3, l4) => {
    if (!map || !rows || rows.length === 0) {
        if (rows && rows.length === 0) cartAlertaDados(ling);
        return;
    }
    if (l1 > rows.length){
        l1 = rows.length;
    }
    if (l2 > rows.length){
        l2 = rows.length;
    }
    if (l3 > rows.length){
        l3 = rows.length;
    }
    if (l4 > rows.length){
        l4 = rows.length;
    }
    let cor = '#008000';
    let ponto = rows[0];
    let campo = Object.keys(ponto);
    for (let i = 0; i < rows.length; i++) {
        if (i === l1){
            cor = '#00FF00';
        }
        if (i === l2){
            cor = '#FFDF00';
        }
        if (i === l3){
            cor = '#FF8C00';
        }
        if (i === l4){
            cor = '#FF0000';
        }
        if (parseInt(rows[i][campo[0]]) < 83) {
            desenhaCirc(rows[i], cor, 4, map);
        }
    }
    let desde = " De " + rows[l1+1][campo[3]].toLocaleString('en-US') + " a ";
    let ate = rows[2][campo[3]].toLocaleString('en-US') + " cartões";
    document.getElementById("verdescuro").innerHTML = desde + ate + " (ranking 1 a " + l1 + ")";
    desde = " De " + rows[l2+1][campo[3]].toLocaleString('en-US') + " a ";
    ate = rows[l1+2][campo[3]].toLocaleString('en-US') + " cartões";
    document.getElementById("verdeclaro").innerHTML = desde + ate + " (ranking " + l1 + " a " + l2 + ")";
    desde = " De " + rows[l3+1][campo[3]] .toLocaleString('en-US')+ " a ";
    ate = rows[l2+2][campo[3]].toLocaleString('en-US') + " cartões";
    document.getElementById("amarelo").innerHTML = desde + ate + " (ranking " + l2 + " a " + l3 + ")";
    desde = " De " + rows[l4+1][campo[3]].toLocaleString('en-US') + " a ";
    ate = rows[l3+2][campo[3]].toLocaleString('en-US') + " cartões";
    document.getElementById("laranja").innerHTML = desde + ate + " (ranking " + l3 + " a " + l4 + ")";
    if (rows.length > 84) {
        desde = " De " + rows[84][campo[3]].toLocaleString('en-US') + " a ";
    } else {
        desde = " De " + rows[rows.length-1][campo[3]].toLocaleString('en-US') + " a ";
    }
    ate = rows[l4+2][campo[3]].toLocaleString('en-US') + " cartões";
    document.getElementById("vermelho").innerHTML = desde + ate + " (ranking " + l4 + " a " + rows.length + ")";
}

export const docartInterv = (ling, map, rows, l1, l2, l3, l4) => {
    if (!map || !rows || rows.length < 1) {
        if (rows && rows.length === 0) cartAlertaDados(ling);
        return;
    }
    let netap;
    let cor = '#008000';
    let ponto = rows[0];
    let campo = Object.keys(ponto);    
    for (let i = 0; i < rows.length; i++) {
        netap = rows[i][campo[3]];
        if (netap<l1){
            cor = '#00FF00';
        }
        if (netap<l2){
            cor = '#FFDF00';
        }
        if (netap<l3){
            cor = '#FF8C00';
        }
        if (netap<l4){
            cor = '#FF0000';
        }
        desenhaCirc(rows[i], cor, 4, map);
    }
    let desde = " De 9,999,999 a ";
    let ate = l1.toLocaleString('en-US') + " cartões";
    document.getElementById("verdescuro").innerHTML = desde + ate;
    desde = " De " + l1.toLocaleString('en-US') + " a ";
    ate = l2.toLocaleString('en-US') + " cartões";
    document.getElementById("verdeclaro").innerHTML = desde + ate;
    desde = " De " + l2.toLocaleString('en-US') + " a ";
    ate = l3.toLocaleString('en-US') + " cartões";
    document.getElementById("amarelo").innerHTML = desde + ate;
    desde = " De " + l3.toLocaleString('en-US') + " a ";
    ate = l4.toLocaleString('en-US') + " cartões";
    document.getElementById("laranja").innerHTML = desde + ate;
    desde = " De " + l4.toLocaleString('en-US') + " a ";
    ate = "0 cartões";
    document.getElementById("vermelho").innerHTML = desde + ate;
}

function cartAlertaDados(ling) {
    if (ling === 'pt') {
        alert ('Não há dados para o período especificado! Só de Set 2020 a Fev 2021, inc. (excepto Abr 2020)');
    } else {
        alert ('No data for the specified period! Only for Sep 2020 to Feb 2021, inc. (Apr 2020 excluded)')
    }
}